(function () {
  document.querySelectorAll('[data-gift-finder]').forEach(function (root) {
    var input = root.querySelector('[data-gift-input]');
    var loading = root.querySelector('[data-gift-loading]');
    var resultPanel = root.querySelector('[data-gift-result]');
    var productContainer = root.querySelector('[data-gift-product]');
    var emptyState = root.querySelector('[data-gift-empty]');
    var suggestBtn = root.querySelector('[data-gift-suggest]');
    var viewAllBtn = root.querySelector('[data-gift-view-all]');
    var viewProductBtn = root.querySelector('[data-gift-view-product]');
    var suggestionButtons = root.querySelectorAll('[data-suggestion]');
    var bestSellersHandle = root.getAttribute('data-best-sellers-collection') || '';
    var fallbackEnabled = root.getAttribute('data-fallback-enabled') === 'true';
    var fallbackCollectionHandle = root.getAttribute('data-fallback-collection') || '';
    var searchTimeout = null;
    var utm = {
      utm_source: 'gift_finder',
      utm_medium: 'onsite',
      utm_campaign: 'gift_finder_page',
    };
    var state = {
      products: [],
      currentIndex: 0,
      currentQuery: '',
    };

    if (!input) return;

    function escapeHtml(text) {
      return String(text).replace(/[&<>"']/g, function (match) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;',
        }[match];
      });
    }

    function appendUtm(url, extra) {
      var params = Object.assign({}, utm, extra || {});
      try {
        var u = new URL(url, window.location.origin);
        Object.keys(params).forEach(function (key) {
          if (params[key] != null && params[key] !== '') {
            u.searchParams.set(key, params[key]);
          }
        });
        return u.pathname + u.search + u.hash;
      } catch (_error) {
        var qs = new URLSearchParams(params).toString();
        return url + (url.indexOf('?') >= 0 ? '&' : '?') + qs;
      }
    }

    function getDisplayTitle(title) {
      if (!title) return '';
      if (title.indexOf(' - ') !== -1) {
        return title.split(' - ').slice(1).join(' - ').trim();
      }
      return title;
    }

    function formatPrice(product) {
      if (!product.price) return '';
      var priceValue = parseFloat(product.price);
      if (Number.isNaN(priceValue)) return '';
      if (priceValue > 1000) priceValue = priceValue / 100;
      return '$' + priceValue.toFixed(2);
    }

    function setLoading(isLoading) {
      if (!loading) return;
      loading.hidden = !isLoading;
      input.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function hideResults() {
      if (resultPanel) resultPanel.hidden = true;
      if (emptyState) emptyState.hidden = true;
    }

    function showEmpty() {
      if (resultPanel) resultPanel.hidden = true;
      if (emptyState) emptyState.hidden = false;
    }

    async function getFallbackProducts() {
      if (!fallbackCollectionHandle) return [];
      try {
        var response = await fetch('/collections/' + fallbackCollectionHandle + '/products.json');
        var data = await response.json();
        return (data.products || [])
          .slice()
          .sort(function () {
            return 0.5 - Math.random();
          })
          .slice(0, 10);
      } catch (error) {
        console.error('Gift finder fallback error:', error);
        return [];
      }
    }

    async function prioritizeBestSellers(products) {
      if (!bestSellersHandle || products.length === 0) return products;
      try {
        var response = await fetch('/collections/' + bestSellersHandle + '/products.json');
        var data = await response.json();
        var bestSellerHandles = (data.products || []).map(function (product) {
          return product.handle;
        });

        return products.slice().sort(function (a, b) {
          var aIndex = bestSellerHandles.indexOf(a.handle);
          var bIndex = bestSellerHandles.indexOf(b.handle);
          if (aIndex !== -1 && bIndex === -1) return -1;
          if (aIndex === -1 && bIndex !== -1) return 1;
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          return 0;
        });
      } catch (error) {
        console.warn('Gift finder best sellers sort failed:', error);
        return products;
      }
    }

    function showProduct(product) {
      if (!productContainer || !resultPanel) return;

      emptyState.hidden = true;
      resultPanel.hidden = false;

      var displayTitle = getDisplayTitle(product.title);
      var imageHtml = product.image
        ? '<img src="' + product.image + '" alt="' + escapeHtml(displayTitle) + '" loading="lazy" width="320" height="320">'
        : '';
      var productType = product.product_type || product.type;
      var typeHtml = productType
        ? '<p class="gift-finder__product-type">' + escapeHtml(productType) + '</p>'
        : '';
      var priceText = formatPrice(product);
      var priceHtml = priceText ? '<p class="gift-finder__product-price">' + priceText + '</p>' : '';
      var rawUrl = product.url || '/products/' + product.handle;
      var trackedUrl = appendUtm(rawUrl, {
        utm_content: 'view_product',
        utm_term: state.currentQuery,
      });

      productContainer.innerHTML =
        '<div class="gift-finder__product-image">' +
        imageHtml +
        '</div>' +
        '<div class="gift-finder__product-info">' +
        '<h2 class="gift-finder__product-title"><a href="' +
        trackedUrl +
        '">' +
        escapeHtml(displayTitle) +
        '</a></h2>' +
        typeHtml +
        priceHtml +
        '</div>';

      if (viewProductBtn) viewProductBtn.href = trackedUrl;
      if (viewAllBtn) {
        viewAllBtn.href = appendUtm('/search?q=' + encodeURIComponent(state.currentQuery), {
          utm_content: 'view_all',
          utm_term: state.currentQuery,
        });
      }
    }

    async function searchProducts(query) {
      var trimmed = (query || '').trim();
      if (trimmed.length < 2) {
        hideResults();
        return;
      }

      state.currentQuery = trimmed;
      setLoading(true);
      hideResults();

      try {
        var searchUrl =
          '/search/suggest.json?q=' +
          encodeURIComponent(trimmed) +
          '&resources[type]=product&resources[limit]=20';
        var response = await fetch(searchUrl);
        var data = await response.json();
        var products = [];

        if (data.resources && data.resources.results && data.resources.results.products) {
          products = data.resources.results.products;
        }

        if (products.length === 0 && fallbackEnabled) {
          products = await getFallbackProducts();
        }

        products = await prioritizeBestSellers(products);
        state.products = products;
        state.currentIndex = 0;

        if (state.products.length > 0) {
          showProduct(state.products[state.currentIndex]);
          resultPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        } else {
          showEmpty();
        }
      } catch (error) {
        console.error('Gift finder search error:', error);
        showEmpty();
      } finally {
        setLoading(false);
      }
    }

    function suggestNext() {
      if (state.products.length === 0) return;
      state.currentIndex = (state.currentIndex + 1) % state.products.length;
      showProduct(state.products[state.currentIndex]);
    }

    input.addEventListener('input', function () {
      clearTimeout(searchTimeout);
      var query = input.value.trim();
      if (query.length < 2) {
        hideResults();
        return;
      }
      searchTimeout = setTimeout(function () {
        searchProducts(query);
      }, 500);
    });

    suggestionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var suggestion = button.getAttribute('data-suggestion') || '';
        input.value = suggestion;
        searchProducts(suggestion);
      });
    });

    if (suggestBtn) {
      suggestBtn.addEventListener('click', suggestNext);
    }
  });
})();
